import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/site/Logo";

export default function Header({ phone = "0906465620" }) {
    const [open, setOpen] = useState(false);

    const links = [
        { href: "#home", label: "Home" },
        { href: "#stock", label: "Stock" },
        { href: "#contact", label: "Contact" },
    ];

    const scrollTo = (e, href) => {
        e.preventDefault();
        setOpen(false);
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-xl border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
                <a
                    href="#home"
                    onClick={(e) => scrollTo(e, "#home")}
                    className="flex items-center"
                    data-testid="header-logo-link"
                >
                    <Logo variant="compact" />
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => scrollTo(e, l.href)}
                            className="text-xs uppercase tracking-[0.25em] text-zinc-300 hover:text-white transition-colors"
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={`tel:${phone.replace(/\s/g, "")}`}
                        className="hidden md:inline-flex items-center gap-2 bg-[#d52b1e] hover:bg-[#f03022] text-white px-4 py-2 uppercase text-xs tracking-[0.2em] font-bold transition-colors"
                        data-testid="header-call-cta"
                    >
                        <Phone className="w-4 h-4" />
                        Call Us
                    </a>
                    <button
                        onClick={() => setOpen(!open)}
                        className="md:hidden text-white p-1"
                        aria-label="Toggle menu"
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X /> : <Menu />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-[#0a0a0a]">
                    <div className="px-5 py-4 flex flex-col gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => scrollTo(e, l.href)}
                                className="text-sm uppercase tracking-[0.25em] text-zinc-300"
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={`tel:${phone.replace(/\s/g, "")}`}
                            className="inline-flex items-center gap-2 bg-[#d52b1e] text-white px-4 py-2 uppercase text-xs tracking-[0.2em] font-bold w-fit"
                        >
                            <Phone className="w-4 h-4" /> Call Us
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
